// @ts-nocheck
import { Outlet, Navigate } from "react-router-dom";

const PrivateRoutes = () => {
  let token = localStorage.getItem("token");
  return token ? <Outlet /> : <Navigate to="/" />;
};

export default PrivateRoutes;
